import { api } from '@everfi/reactifi';
import { routerReducer as routing } from 'react-router-redux';

const reducerExports: any = { api, routing };
export default reducerExports;
